import { type PMPluginFactoryParams } from '@atlaskit/editor-common/types';
import { type EditorView } from '@atlaskit/editor-prosemirror/view';

import { streamingService } from '../../../experience-application/streaming-service';
import type { EditorPluginAIProvider } from '../../../types';
import { type StreamingCallback } from '../types';
import { type getConfigItem } from '../utils/config-utils';

export const handleStreamingService = ({
	getIntl,
	editorPluginAIProvider,
	currentEditorView,
	configItem,
	streamingCallback,
}: {
	getIntl: PMPluginFactoryParams['getIntl'];
	editorPluginAIProvider: EditorPluginAIProvider;
	currentEditorView: EditorView;
	configItem: ReturnType<typeof getConfigItem>;
	streamingCallback: StreamingCallback;
}) => {
	const intl = getIntl();
	const context = {
		aiProvider: editorPluginAIProvider,
		editorView: currentEditorView,
		configItem: configItem,
		intl: intl,
		positions: [0, 0],
		responseHistory: [],
	};
	const event = {};
	streamingCallback({
		type: 'initialising',
	});
	// @ts-expect-error
	// We expect a type error here since we're manually constructing the aiExperienceContext object
	const callbackHandler = streamingService(context, event);
	callbackHandler((streamData) => {
		if (streamData) {
			// @ts-ignore callbackHandler's type expectation is too wide, need to narrow down
			switch (streamData.type) {
				case 'stream': {
					if (streamData.loadingStatus === 'ANALYSING_QUERY') {
						streamingCallback({
							type: 'analysingQuery',
						});
					} else {
						streamingCallback({
							type: 'streaming',
							result: streamData.markdown,
						});
					}
					break;
				}
				case 'complete': {
					streamingCallback({
						type: 'complete',
						result: streamData.markdown,
					});
					break;
				}
				case 'error':
					streamingCallback({
						type: streamData.type,
						errorInfo: streamData.errorInfo,
					});
					break;
				case 'response too similar': {
					streamingCallback({
						type: streamData.type,
					});
					break;
				}
				default: {
					break;
				}
			}
		}
	});
};
